import React from 'react'
import Dropzone from 'react-dropzone'

import { bytesToSize } from '../../../helpers/general'
import imageCompression from 'browser-image-compression'

import jpgIcon from '../../../assets/icons/jpg.png'
import pdfIcon from '../../../assets/icons/pdf.png'
import pngIcon from '../../../assets/icons/png.png'

const UploadART = ({
  files,
  setFiles,
  multiple = false,
  accept = 'image/*'
}) => {

  const handleAccept = async(file)=>{
    var options = {
      maxSizeMB: 2,
      onProgress: Function,
      maxWidthOrHeight: 1080,
      useWebWorker: true
    }
    const compressedFile = await imageCompression(file[0], options)
    const compressed = new File([compressedFile], file[0].name)
    
    setFiles([compressed])
 
  }
  


  const handleReject = event => {}

  return (
    <React.Fragment>
      {files && files.length > 0 ? (
        <div
          className="d-flex w-100 flex-column border rounded px-4 py-2"
          style={{ backgroundColor: 'inherit' }}
        >
          {files.map((file, index) => (
            <div
              key={index}
              className="d-flex justify-content-between align-items-center"
            >
              <div className="d-flex w-100 flex-row justify-content-between align-items-center py-2">
                {file.type === 'image/jpeg' || file.type === 'image/jpg' ? (
                  <img src={jpgIcon} style={{ width: '30px' }} alt="" />
                ) : file.type === 'image/png' ? (
                  <img src={pngIcon} style={{ width: '30px' }} alt="" />
                ) : file.type === 'application/pdf' ? (
                  <img src={pdfIcon} style={{ width: '30px' }} alt="" />
                ) : (
                  ''
                )}
                <div className="d-flex flex-column flex-grow-1 ml-4">
                  <div>{file.name}</div>
                  <small className="text-muted">{bytesToSize(file.size)}</small>
                </div>
              </div>
              <i
                className="fas fa-times"
                onClick={() => {
                  setFiles(files.filter((file, i) => i !== index))
                }}
                style={{ cursor: 'pointer' }}
              />
            </div>
          ))}
        </div>
      ) : (
        <Dropzone
          multiple={multiple}
          onDrop={handleAccept}
          onRejected={event => handleReject(event)}
          accept={accept}
        >
          {({ getRootProps, getInputProps }) => (
            <div
              {...getRootProps({
                className:
                  'd-flex w-100 flex-column justify-content-center align-items-center rounded text-center p-4',
                style: { border: '2px dashed #e3e3e3' }
              })}
            >
              <input {...getInputProps()} />
              <i className="fas fa-upload fa-3x text-brand"></i>
              <p className="pt-3">You can also upload files by</p>
              <p className="text-brand">Clicking here</p>
            </div>
          )}
        </Dropzone>
      )}
    </React.Fragment>
  )
}

export default UploadART
